


























import Vue from 'vue'
import { SystemNetwork } from '@/types/api'
import easyapi from '@/easyapi'
import { reqMan } from '@/singleton'

export default Vue.extend({
  computed: {
    netStatus (): SystemNetwork { return this.$s.$state.sys.network.status }
  },
  methods: {
    showEditDialog () {
      this.$router.push({ name: 'sys_network_edit' })
    }
  },
  mounted () {
    reqMan.ensureWsAvailable(() => {
      easyapi.fetchNetworkStatus()
    })
  }
})
